import { MerchantBalance } from "@components/balance";
import { FlexLoader } from "@components/loader";
import { Operations } from "@components/operations";
import { PayOutBalanceModal } from "@components/pay-out-balance-modal";
import { TransactionsInfo } from "@components/transactions-info";
import { useMerchantBalance } from "@features/merchantBalance";
import { useBoolState } from "@hooks/use-bool-state";
import { useNavigateWithUserId } from "@hooks/use-navigate";
import styles from "./finance.module.scss";
import { useEffect } from "react";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const FinancePage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const { state, getBalances } = useMerchantBalance();
  const { lastMessage } = useWebSocket();

  const websocketTypesToUpdateBalance = [
    WebsocketUpdateType.Balance,
    WebsocketUpdateType.Withdrawal,
    WebsocketUpdateType.Appeal,
    WebsocketUpdateType.Order,
    WebsocketUpdateType.PayOut,
  ];

  useEffect(() => {
    if (
      lastMessage &&
      websocketTypesToUpdateBalance.includes(lastMessage.type)
    ) {
      getBalances();
    }
  }, [lastMessage]);
  useEffect(() => {
    getBalances();
  }, []);

  const navigate = useNavigateWithUserId();

  if (!state.balance) {
    return <FlexLoader />;
  }

  return (
    <>
      <div className={styles.finance}>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            <MerchantBalance
              className={styles.wallet}
              balance={state.balance.sum_usdt}
              onClickWithdraw={showModal}
              onClickHistory={() => navigate("settlements")}
            />
          </div>
          <TransactionsInfo
            profit={state.balance?.ern_balance?.amount ?? 0}
            formatType="usdt"
          />
        </div>
        <Operations />
      </div>
      <PayOutBalanceModal
        isModalOpen={isModalOpen}
        hideModal={hideModal}
        balance={Math.round(state.balance.sum_usdt * 100) / 100}
      />
    </>
  );
};
